import { CollapseExpand } from "../../../components/CollapseExpand";
import { functionalIndicators, mainAlgoCreationPanels, technicalIndicators } from "./AlogPanels";
import Picture from "./Picture";
import {ReactComponent as CirclePlus} from '../../../assets/image/icons/circle-plus.svg';

const getFundamentalIndicator = (title, key) => {
    return <div className="w-full h-[30px] border border-solid border-[#0061FC] rounded-[30px] uppercase text-white text-xs flex flex-row items-center gap-[10px]" key={`functional-${key}`}>
        <CirclePlus className='w-[23px] ml-[3px] cursor-pointer' />{title}
    </div>
}

export const LeftPanel = () => {
    return (
        <div className={`left-panel w-[300px] h-full bg-[#001639] flex flex-col overflow-auto no-scrollbar`}>
            <div className="flex flex-col">
                <div className="flex flex-col h-[60px] w-full border-b border-[#ffffff] text-[#ffffff] text-[15px] leading-7  pl-[30px] justify-center opacity-[0.4]">FUNCTIONS</div>
                <div className="border-b border-white">
                <CollapseExpand title={"Main Components"} expanded={true}>
                    <div className="px-[30px] flex flex-col gap-[10px] pb-[15px]">
                        {mainAlgoCreationPanels.map((picture, index) => {
                            // if(index === 0) {
                            //     return <>
                            //         <Picture url={picture.url} id={picture.id} key={`mainAlgo-${index}`} accepts={"mainPanel"} icon={picture.icon} />
                            //         <br />
                            //     </>
                            // }
                            if(index === 1) {
                                return <>
                                    <Picture url={picture.url} id={picture.id} key={`mainAlgo-${index}`} accepts={"conditionalPanel"} icon={picture.icon}/>
                                    <br />
                                </>
                            }
                            else {
                                return <Picture url={picture.url} id={picture.id} key={`mainAlgo-${index}`} accepts={"conditionalPanel"} icon={picture.icon}/>
                            }
                        })}
                    </div>
                </CollapseExpand>
                </div>
                <div className="border-b border-white">
                    <CollapseExpand title={"Technical Indicators"} expanded={false}>
                        <div className="px-[30px] flex flex-col gap-[0px] pb-[15px]">
                            {technicalIndicators.map((indicator, index) => <Picture url={indicator.url} id={indicator.id} key={`technical-${index}`} accepts={index === 3 ? '' :"technicalPanel"} icon={indicator.icon}/> )}
                        </div>
                    </CollapseExpand>
                </div>
                <CollapseExpand title={"Fundamental Indicators"} expanded={false}>
                    <div className="px-[30px] flex flex-col gap-[10px] pb-[15px]">
                        {functionalIndicators.map((indicator, index) => getFundamentalIndicator(indicator, index))}
                    </div>
                </CollapseExpand>
            </div>
        </div>
    );
};